import React, { memo } from 'react';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { Usage360GuideStyled, Usage360GuidTextStyled, View360GuideWrapperStyled } from './styled';
function Usage360GuideElement({ text, image, isRightToLeft }) {
    const { isMobileView } = useWindowSize();
    return (React.createElement(View360GuideWrapperStyled, { isMobileView: isMobileView },
        React.createElement(Usage360GuideStyled, { isRightToLeft: isRightToLeft },
            React.createElement(Usage360GuidTextStyled, { isRightToLeft: isRightToLeft, iconUrl: image }, text))));
}
export const Usage360Guide = memo(Usage360GuideElement);
